import { Component, Inject } from '@angular/core';
import { DashboardResolvedModelComponent } from '../dashboard-resolved-model/dashboard-resolved-model.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnUtilService, FnToasterService } from 'foundation';
import { PosHttpService } from '../../../services/pos.http.service';

@Component({
  selector: 'app-dashboard-all-resolved-component',
  templateUrl: './dashboard-all-resolved-component.component.html',
  styleUrl: './dashboard-all-resolved-component.component.scss'
})
export class DashboardAllResolvedComponentComponent {
  ntArr: Array<any> = [];
  isSendTelegram: boolean = false;
  isSelected: boolean = false;
  commentObject: { textComment: string } = { textComment: '' };

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData,
    private dialogRef: MatDialogRef<DashboardResolvedModelComponent>,
    private fnutilservice: FnUtilService,
    private toaster: FnToasterService,
    private posHttpSvcs: PosHttpService
  ) { }

  addComment(): void {
    if (this.fnutilservice.isEmptyObject(this.commentObject.textComment)) {
      this.toaster.error('Please add comment here...');
      return
    }
    const pktData = {
      commentText: this.commentObject.textComment,
      isSendTelegram: this.isSendTelegram,
      pk: this.dialogData.resolve
    };
    this.posHttpSvcs.authPost('v1/ui/resolve', 'resolve', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error(resp.data);
        return;
      } else {
        this.toaster.success(resp.data);
        if (this.isSendTelegram) {
          this.sendtoTelegram();
        }
      }
      this.commentObject.textComment = '';
      this.dialogRef.close(resp.isError);
    }));
  }

  sendtoTelegram(): void {
    const pktData = {
      msg: this.commentObject.textComment,
      pk: this.dialogData.resolve,
      action : 'Resolved'
    };
    this.posHttpSvcs.authPost('v1/ui/generateTelegram', 'generateTelegram', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error("Telegram Msg not saved");
        return;
      }
    }));
  }

  close() {
    this.dialogRef.close();
  }

  selectionCheck(event: any): void {
    this.isSelected = event.target.checked;
    }
}

interface HwDialogData {
  resolve: any;
}

